import React from "react";
import AboutSection from "../about-section";
import ClientSection from "../client-section";
import ContactSection from "../contact-section";
import FAQSection from "../faq-section";
import ServiceSection from "../service-section";
import TestimonialSection from "../testimonial-section";
const MainSection = () => {
  return (
    <React.Fragment>

<section id="hero" class="d-flex align-items-center">

<div class="container" data-aos="zoom-out" data-aos-delay="100">
  <div class="row">
    <div class="col-xl-12">
      <h1>Progress Solution</h1>
      <h2>Progress Solution is an electronics repair shop specializing in Laptop and Computer repairs. We are known for our advanced Micro-soldering services, Motherboard repairs and others.</h2>
    </div>
  </div>
</div>

</section>

      <main id="main">
        <ClientSection/>
        <AboutSection/>
        <ServiceSection/>
        <TestimonialSection/>
        <ContactSection/>
        {/* <FAQSection/> */}
      </main>
    </React.Fragment>
  );
};

export default MainSection;
